import { render } from "./ordentrabajoservicio.vue?vue&type=template&id=20914195"
import script from "./ordentrabajoservicio.vue?vue&type=script&lang=js"
export * from "./ordentrabajoservicio.vue?vue&type=script&lang=js"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__